import {ColumnFilterItem} from 'antd/lib/table';
import locales from '../locales';

export const enum DepositState {
  YES = 'YES',
  NO = 'NO',
}

const depositStates = [
  DepositState.YES,
  DepositState.NO,
];


const stateToText = {
  [DepositState.YES]: locales.has,
  [DepositState.NO]: locales.hasNot,
};

export function getRentalItemDepositStateFilters(): ColumnFilterItem[] {
  return depositStates
    .map(state => ({text: stateToText[state], value: state}));
}



// WEBPACK FOOTER //
// ./src/common/depositState.tsx